import { FC } from "react";
import { CardDataType, DataMap } from "src/Modules/UserHistory/pages/OrdersList/components/OrderCard/constants";
import { transformRecord } from "src/utility";
import { useTranslation } from "react-i18next";
import { CopyIcon } from "src/assets/Icons";
import { useToast } from "src/context";

const BookingSummary: FC<{
  cardData: Pick<CardDataType, "data" | "tag" | "title"> & { orderId?: string };
  dataMap: DataMap;
}> = ({
  cardData,
  dataMap,
}) => {
  const { t } = useTranslation();
  const toast = useToast();
  const { title, tag, data, orderId } = cardData;
  const handleCopy = () => {
    navigator.clipboard.writeText(orderId ?? "");
    toast.success(t("UserHistory.giftcard.copiedToClipboard"));
  };
  return (
    <div className="bg-background-default flex flex-col gap-4 rounded-sm p-5 shadow-sm">
      <div className="flex items-center justify-between gap-1">
        <div className="text-lg font-medium">{title}</div>
        <div>{tag}</div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="text-font-minimal flex items-center gap-2 text-xs">
          <div>{t("UserHistory.orderDetails.orderId")} </div>
          <div>
            {orderId && (
              <button type="button" onClick={handleCopy} aria-label={t("UserHistory.orderDetails.copyOrderId")} className="cursor-pointer">
                <CopyIcon className="text-icon-subtle size-3" />
              </button>
            )}
          </div>
        </div>
        <div className="text-3xl font-bold leading-tight tracking-wider">{orderId}</div>
      </div>
      <div className="bg-border-subtle h-px w-full"></div>
      <div className="flex flex-wrap items-center gap-5">
        {transformRecord(data ?? {}, dataMap).map(({ key, label, display }) =>
          display == null ? null : (
            <div key={key} className="flex flex-col gap-1">
              <div className="text-font-minimal text-xs">{label}</div>
              <div className="font-medium">{display}</div>
            </div>
          ),
        )}
      </div>
    </div>
  );
};

export default BookingSummary;
